const ACTIVE = 'Activo';
const INACTIVE = 'Inactivo';

const statusesList = [ACTIVE, INACTIVE];

// Convert boolean to string for display
const getStatusText = (isActive) => (isActive ? 'Activo' : 'Inactivo');

// Convert string back to boolean for API
const getStatusBoolean = (statusText) => statusText === 'Activo';

module.exports = {
  ACTIVE,
  INACTIVE,
  statusesList,
  getStatusText,
  getStatusBoolean,
};
